<template>
  <span>
    <v-btn variant="outlined" color="primary" @click="dialog = true">
      {{ $t('models_and_train_configs.import_model_button') }}
    </v-btn>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ $t('models_and_train_configs.import_model_title') }}</v-card-title>
        <v-card-text>
          <p class="mb-3">{{ $t('models_and_train_configs.import_model_hint') }}</p>
          <v-file-input
            v-model="file"
            accept=".zip"
            :label="$t('models_and_train_configs.import_model_file_label')"
            :disabled="uploading"
          ></v-file-input>
          <v-progress-linear v-if="uploading" :model-value="progress" height="20" rounded color="primary">
            <strong>{{ progress }}%</strong>
          </v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="uploading" @click="close">
            {{ $t('models_and_train_configs.cancel_button') }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="uploading"
            :disabled="!selected_file"
            @click="importModel"
          >
            {{ $t('models_and_train_configs.import_model_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: "ImportModelButton",
  data() {
    return {
      dialog: false,
      file: null,
      uploading: false,
      progress: 0,
    };
  },
  computed: {
    selected_file() {
      if (Array.isArray(this.file)) {
        return this.file[0] || null;
      }
      return this.file || null;
    },
  },
  methods: {
    close() {
      if (this.uploading) {
        return;
      }
      this.dialog = false;
      this.file = null;
      this.progress = 0;
    },
    async importModel() {
      const file = this.selected_file;
      if (!file) {
        return;
      }
      this.uploading = true;
      this.progress = 0;
      try {
        const response = await this.$api.model.importBundle(file, (pct) => {
          this.progress = pct;
        });
        if (!response) {
          this.$store.dispatch(
            'snackbars/add_failed_snack',
            this.$t('models_and_train_configs.import_model_failed'),
          );
          return;
        }
        if (response.error) {
          this.$store.dispatch('snackbars/add_failed_snack', response.error);
          return;
        }
        if (response.data && response.data.error) {
          this.$store.dispatch('snackbars/add_failed_snack', response.data.error);
          return;
        }
        this.$store.dispatch(
          'snackbars/add_success_snack',
          this.$t('models_and_train_configs.import_model_success'),
        );
        this.dialog = false;
        this.file = null;
        this.$emit('imported');
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
